import { useState, useEffect } from 'react';
import TableComponent from '../../../../components/table';
import { Spin } from 'antd';
import PaginationComponent from '../../../../components/pagination';
import Api from "../../../../services/api";
import { networkIcons } from '../../../../utility';

const AppAdPerformance = (props) => {
  const [appAdPerformance,setAppAdPerformance] = useState([]);
  const [page,setPage] = useState(1);
  const [sort,setSort] = useState({});
  const [loading,setLoading] = useState(true);
  const [filterName, setFilterName] = useState('');
  const [activeFilterKey, setActiveFilterKey] = useState(null);

	useEffect(() => {
    setLoading(true)
    Api.get(`api/overview/ad_performance?os=${props.os}&from=${props.startDate.format('YYYY-MM-DD')}&to=${props.endDate.format('YYYY-MM-DD')}&code=${props.code}&country=${props.country}&ad_network=${props.adnetwork}&campaign=${props.campaign}&sort_value_by=${props.sortValue}&sort_by_column=${sort.column || ''}&sort_by_column_value=${sort.value || ''}&name=${filterName}&page=${page}`)
    .then(result => {
      if(result?.data?.code === 0){
        setAppAdPerformance(result.data)
        setLoading(false)
      }
    });
  }, [props.filter, props.reload ,props.sortValue,page,sort,filterName]);

  const handleChangePage = (page) => {
    setPage(page);
  }

  const handleFilterName = (value, key) => {
    if (key === 'name') {
      setFilterName(value); 
      setPage(1); 
    }
  };

  const handleSort = (key) => {
    const arr = key.split('-')
    setSort({
      column : arr[0],
      value : arr[1]
    })
  }

  const handleFilter = (e, key) => {
    console.log(e,key)
  }

  useEffect(() => {
    const handleClickOutside = () => {
      setActiveFilterKey(null);
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <Spin spinning={loading}>
    <TableComponent 
      sort="1"
      filter={true}
      column={[{
        key : 'name',
        name : 'Name',
        customRender: (value, item) => {
          const displayValue = value?.value || value?.format || value;
          
          return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {item?.network?.value && networkIcons[item.network.value] && (
            <img 
              width="15px" 
              height="15px" 
              src={`/icon/${networkIcons[item.network.value]}`}
              alt={item.network.value}
              style={{ marginRight: '8px', borderRadius: "8px" }}
            />
            )}
            <span style={{ overflow : "hidden" , textOverflow: "ellipsis" , whiteSpace: "nowrap"}}>{displayValue}</span>
          </div>
          );
        }
      },{
        key : 'cost',
        name : 'Cost ($)',
      },{
        key : 'install',
        name : 'Installs',
      },{
        key : 'impressions',
        name : 'Impressions',
      },{
        key : 'ecpm',
        name : 'eCPM',
      },{
        key : 'ipm',
        name : 'IPM',
      }]}
      data={appAdPerformance.data || []}
      handleFilter={handleFilter}
      handleFilterName={handleFilterName}
      sort={handleSort}
      tableKey="ad_performance_table"
      activeFilterKey={activeFilterKey}
      setActiveFilterKey={setActiveFilterKey}
    />
    <PaginationComponent 
      current={appAdPerformance.page}
      total={appAdPerformance.total_page}
      handleChangePage={handleChangePage} />
    </Spin>
  )
}
export default AppAdPerformance;